/*
 * @Author: HB-BruceWang
 * @Date: 2025-05-22 17:03:56
 * @LastEditors: HB-BruceWang
 * @LastEditTime: 2025-05-28 11:38:23
 * @FilePath: \shopify-web\src\components\snippets\purchase-intention-form\index.js
 * @Description: 购买意向表单
 *
 * Copyright (c) 2025 by Hello Tech, All Rights Reserved.
 */

import "./index.less";
import { googleRobotCheck } from "@utils/fetch.js";

(function () {
  document.addEventListener("DOMContentLoaded", function () {

    // Interested Products - 选择其他选项并输入自定义文本时，则自动填充到复选框值中
    const purchaseForm = document.querySelector('.purchase-intention-form');
    const otherInput = purchaseForm.querySelector('.other-inp');
    const otherCheckbox = purchaseForm.querySelector('.other-checkbox');

    // 页面链接
    purchaseForm.querySelector('.page-url').value = window.location.href;

    // 处理输入框值变化
    const handleInputChange = (event) => {
      const val = event.target.value;
      event.target.classList.toggle('active', !val);

      if (val) {
        otherCheckbox.value = val;
        // 触发 change 事件
        otherCheckbox.dispatchEvent(new Event('change', {
          bubbles: true,
          cancelable: true
        }));
      }
    };

    // 处理复选框状态变化
    const handleCheckboxChange = (event) => {
      if (!otherInput.value) {
        const isChecked = event.target.checked;
        otherInput.classList.toggle('active', isChecked);
        isChecked ? otherInput.focus() : otherInput.blur();
      }
    };

    // 绑定事件监听
    otherInput.addEventListener('input', handleInputChange);
    otherCheckbox.addEventListener('change', handleCheckboxChange);

    // 谷歌人机验证
    function recaptchaReady() {
      grecaptcha.enterprise.ready(function () {
        const grecaptchaID = grecaptcha.enterprise.render('renderRobotCheck', {
          'sitekey': '6Le9b0krAAAAAH_ROP2_Lw3kp1mVpmj7ZwIeGI0S',
          "action": "submit",
          'theme': 'light',  // 使用浅色主题
          'size': 'normal',  // 正常大小的复选框
          'callback': function (token) {

            // 获取状态元素
            const recaptchaStatus = document.querySelector('#recaptchaStatus');

            googleRobotCheck({
              token,
              actionName: 'submit',
            }).then(res => {
              if (res && res.code === 200) {
                if (res.data) {
                  // 验证成功
                  recaptchaStatus.value = 'success';
                } else {
                  // 验证失败
                  recaptchaStatus.value = '';
                }
                // 触发input事件
                recaptchaStatus.dispatchEvent(new Event('input', {
                  bubbles: true,
                  cancelable: true
                }));
              }
            }).catch(err => {
              grecaptcha.reset(grecaptchaID)
            })
          },
          'expired-callback': function () {
            grecaptcha.reset(grecaptchaID);
          },
        });
      });
    }
    // 判断是否存在谷歌验证码容器元素
    if (document.querySelector('#renderRobotCheck')) {
      recaptchaReady();
    }
  })
})();